import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";

import {
  AppLayout,
  Box,
  BreadcrumbGroup,
  Button,
  Checkbox,
  ColumnLayout,
  Container,
  ContentLayout,
  Flashbar,
  FormField,
  Header,
  HelpPanel,
  Input,
  Link,
  Modal,
  SideNavigation,
  SpaceBetween,
  Spinner,
  SplitPanel,
  StatusIndicator,
} from "@cloudscape-design/components";
// import { Navigation } from "../../../components/app/Navigation";
import Icon from "@cloudscape-design/components/icon";
// import { dataUnit } from "../../dashboard/data";
// import { Grid,  } from '@cloudscape-design/components';
import DetailDashboard from "./component/DetailDashboard";
import { Navigation } from "../../../components/app/Navigation";
import { updateTyre, deleteTyre } from "../../../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { TyreMasterTable } from "../w_tyre/data";
import { listTyres } from "../../../graphql/queries";
import { ListTyresQueryVariables } from "../../../API";
import DetailOverview from "./component/DetailOverview";
import { fetchAuthSession } from "aws-amplify/auth";

// get user belong to what group and make it into string
async function checkUserGroup() {
  try {
    const { tokens } = await fetchAuthSession();
    // Normalize user groups to be an array of strings
    const groups = tokens?.accessToken.payload["cognito:groups"];
    if (Array.isArray(groups)) {
      return groups as string[]; // Safe to cast as string[]
    } else if (typeof groups === "string") {
      return [groups]; // Convert a single string to an array
    } else {
      return []; // Default to an empty array if not an array or string
    }
  } catch (error) {
    console.error("Error fetching user groups:", error);
    return []; // Default to an empty array in case of an error
  }
}

async function checkCurrentUser(): Promise<{
  username: string;
  email: string | null;
}> {
  try {
    const { tokens } = await fetchAuthSession();
    // extract the user's information from the accessToken or idTOken
    const currentUser = tokens?.idToken?.payload || tokens?.accessToken.payload;

    if (currentUser) {
      const username =
        typeof currentUser["cognito:username"] === "string"
          ? currentUser["cognito:username"]
          : ""; //fallback if username is empty

      const email =
        typeof currentUser.email === "string" ? currentUser.email : null;
      return { username, email };
    } else {
      console.error("No User Infromation found.");
      return { username: "", email: null };
    }
  } catch (error) {
    console.error("Error fetching current user information:", error);
    return { username: "", email: null };
  }
}



interface FlashbarItem {
  type: "info" | "warning" | "error" | "success"; // Adjust according to your requirements
  dismissible: boolean;
  dismissLabel: string;
  onDismiss: () => void;
  content: React.ReactNode;
  id: string;
}

async function deleteTyreApi(id: string) {
  try {
    const client = generateClient();
    await client.graphql({
      query: deleteTyre,
      authMode: "userPool",
      variables: {
        input: {
          id,
        },
      },
    });
  } catch (err) {
    console.log("Error deleting tyre: ", err);
  }
}

async function updateTyreApi(
  id: string,
  serialnumber: string,
  brand: string,
  typetyre: string,
  vehiclecode: string,
  position: number,
  sensorid: number,
  pressure: number,
  temperature: number,
  battery: number,
  status: boolean
) {
  try {
    const client = generateClient();
    await client.graphql({
      query: updateTyre,
      authMode: "userPool",
      variables: {
        input: {
          id: id,
          serialnumber: serialnumber,
          brand: brand,
          typetyre: typetyre,
          vehiclecode: vehiclecode,
          position: position,
          sensorid: sensorid,
          pressure: pressure,
          temperature: temperature,
          battery: battery,
          status: status,
        },
      },
    });
  } catch (err) {
    console.log("Error updating tyre: ", err);
  }
}

const TyreDetail: React.FC = () => {
  const [activeHref, setActiveHref] = React.useState("/vehicles/tyres");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const { name } = useParams<{ name: string }>();
  const [isModalDeleteVisible, setModalDeleteVisible] = useState(false);
  const [isModalUpdateVisible, setModalUpdateVisible] = useState(false);
  const [itemsFlashbar, setItemsFlashbar] = useState<FlashbarItem[]>([]);
  const [itemsFlashbar2, setItemsFlashbar2] = useState<FlashbarItem[]>([]);
  const navigate = useNavigate();
  let { SerialNumber } = useParams();

  const [tyreList, setTyreList] = useState<TyreMasterTable[]>([]);
  const vehicleIdRef = useRef<string | null>(null);

  const [tyreSN, settyreSN] = useState("");
  const [tyreBrand, settyreBrand] = useState("");
  const [tyreTipe, settyreTipe] = useState("");
  const [tyreVehicleCode, settyreVehicleCode] = useState("");
  const [tyrePosition, settyrePosition] = useState(0);
  const [tyreSensorId, settyreSensorId] = useState(0);
  const [tyrePressure, settyrePressure] = useState(0);
  const [tyreTemperature, settyreTemperature] = useState(0);
  const [tyreBattery, settyreBattery] = useState(0);
  const [tyreStatus, settyreStatus] = useState(false);
  const [checked, setChecked] = useState(false);
  const [userGroups, setUserGroups] = useState<string[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  const [currentUser, setCurrentUser] = useState<string>("");
  const [currentUserEmail, setCurrentUserEmail] = useState<string>("");

  // TimeStamp for log Format
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");
  const timestamp = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;



  useEffect(() => {
    async function initialize() {
      const groups = await checkUserGroup();
      const user = await checkCurrentUser();
      setCurrentUser(user.username);
      setCurrentUserEmail(user.email ?? "");
      setUserGroups(groups);
      fetchTyre();
    }
    initialize();
  }, []);

  const fetchTyre = async (limit = 100) => {
    try {
      const client = generateClient();
      let nextToken: string | null = null;
      let allTyres: TyreMasterTable[] = [];
      do {
        const variables: ListTyresQueryVariables = { limit, nextToken };
        let response = await client.graphql({
          query: listTyres,
          authMode: "userPool",
          variables,
        });

        const tyres = response.data.listTyres.items;
        nextToken = response.data.listTyres.nextToken ?? null;

        const newTyres: TyreMasterTable[] = tyres.map((tyre: any) => {
          const formattedTimestamp = new Date(tyre.updateAt).toLocaleString();
          return {
            id: tyre.id,
            sn: tyre.serialnumber ?? "",
            tyreId: tyre.position ?? 0,
            sensorId: tyre.sensorid ?? "",
            brand: tyre.brand ?? "",
            typetyre: tyre.typetyre ?? "",
            VehicleCode: tyre.vehiclecode ?? "",
            pressure: tyre.pressure ?? 0,
            temperature: tyre.temperature ?? 0,
            battery: tyre.battery ?? 0,
            Status: Boolean(tyre.status),
            Timestamps: formattedTimestamp ?? "",
          };
        });

        allTyres = [...allTyres, ...newTyres];
      } while (nextToken);

      const filteredTyres = allTyres.filter((tyre) => tyre.sn === SerialNumber);
      setTyreList(filteredTyres);
      setIsLoading(false);

      {
        /*if (filteredTyres.length > 0) {
        //const timestamp = new Date(filteredTyres[0].Timestamps);
        //const formattedTimestamp = timestamp.toLocaleString();
        setItemsFlashbar([
          {
            type: "info",
            dismissible: true,
            dismissLabel: "Dismiss message",
            onDismiss: () => setItemsFlashbar([]),
            content: `Fetching Data Succedeed`,
            id: "message_1",
          },
        ]);
      } else {
        setItemsFlashbar([
          {
            type: "info",
            dismissible: true,
            dismissLabel: "Dismiss message",
            onDismiss: () => setItemsFlashbar([]),
            content: "No tyre data found.",
            id: "message_2",
          },
        ]);
      }*/
      }
    } catch (err) {
      console.log("Error fetching tyres : ", err);
      setItemsFlashbar([
        {
          type: "error",
          dismissible: true,
          dismissLabel: "Dismiss message",
          onDismiss: () => setItemsFlashbar([]),
          content: "Error fetching tyre data.",
          id: "message_3",
        },
      ]);
    }
  };

  const handleDelete = async () => {
    setModalDeleteVisible(false);
    if (tyreList.length > 0) {
      // Extract the ID of the first vehicle in the list (you can customize this logic)
      const tyreIdToDelete = tyreList[0].id;
      await deleteTyreApi(tyreIdToDelete);
      // Log Transaction of delete tyre
      console.log(
        `Vehicle Detail Transaction Log (Delete Item):
      Tyre ID : ${tyreList[0].id}
      Tyre SN : ${tyreList[0].sn}
      Tyre Brand : ${tyreList[0].brand}
      Tyre Tipe : ${tyreList[0].typetyre}
      Tyre Vehicle Code : ${tyreList[0].VehicleCode}
      Tyre Position : ${tyreList[0].tyreId}
      Tyre Sensor ID : ${tyreList[0].sensorId}
      Tyre Status : ${tyreList[0].Status}
      User Group : ${userGroups}
      User : ${currentUser}
      user Email : ${currentUserEmail}
      Timestamp : ${timestamp}`
      );

      setItemsFlashbar2([
        {
          type: "success",
          dismissible: true,
          dismissLabel: "Dismiss message",
          onDismiss: () => setItemsFlashbar2([]),
          content: "Tyre successfully deleted.",
          id: "message_4",
        },
      ]);
      navigate("/vehicles/tyres/");
    }
  };

  const handleUpdate = async () => {
    setModalUpdateVisible(false);
    if (tyreList.length > 0) {
      const tyreIdToUpdate = tyreList[0].id;
      await updateTyreApi(
        tyreIdToUpdate,
        tyreSN,
        tyreBrand,
        tyreTipe,
        tyreVehicleCode,
        tyrePosition,
        tyreSensorId,
        tyrePressure,
        tyreTemperature,
        tyreBattery,
        tyreStatus
      );


      // Log Transaction of update tyre
      console.log(
        `Tyre Transaction Log (Update Item):
        Tyre ID : ${tyreList[0].id}
        Tyre SN : ${tyreSN}
        Tyre Brand : ${tyreBrand}
        Tyre Tipe : ${tyreTipe}
        Tyre Vehicle Code : ${tyreVehicleCode}
        Tyre Position : ${tyrePosition}
        Tyre Sensor ID : ${tyreSensorId}
        Tyre Status : ${tyreStatus}
        User Group: ${userGroups}
        User : ${currentUser}
        User Email : ${currentUserEmail}
        Timestamp : ${timestamp}`
      );

      setItemsFlashbar2([
        {
          type: "success",
          dismissible: true,
          dismissLabel: "Dismiss message",
          onDismiss: () => setItemsFlashbar2([]),
          content: "Tyre successfully updated.",
          id: "message_5",
        },
      ]);
      fetchTyre(); // Refresh the vehicle list after update
    }
  };

  const handleEditButtonClick = () => {
    setModalUpdateVisible(true);
    if (tyreList.length > 0) {
      const tyre_ = tyreList[0];
      settyreSN(tyre_.sn);
      settyreBrand(tyre_.brand);
      settyreTipe(tyre_.typetyre);
      settyreVehicleCode(tyre_.VehicleCode);
      settyrePosition(tyre_.tyreId);
      settyreSensorId(tyre_.sensorId);
      settyrePressure(tyre_.pressure);
      settyreTemperature(tyre_.temperature);
      settyreBattery(tyre_.battery);
      settyreStatus(tyre_.Status);
      setModalUpdateVisible(true);
    }
  };

  const handleDeleteConfirmation = () => {
    setModalDeleteVisible(true);
  };

  // To disable or enable button CRUD
  const isButtonDisabled =
    userGroups.includes("user_guest") || userGroups.includes("operator");
  const isUpdateButtonDisabled = userGroups.includes("user_guest");

  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "Vehicles",
                href: "/vehicles",
              },
              {
                text: "Tyres",
                href: "/vehicles/tyres/",
              },
              {
                text: `S/N : ${SerialNumber}`,
                href: `/vehicles/tyres/${SerialNumber}`,
              },
            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref}
            adminSubMenuOpen={false}
            setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error("Function not implemented.");
            }} // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
          // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
          />
        }
        //navigationOpen={true}
        //   navigation={
        //     <Navigation activeHref={activeHref} setActiveHref={setActiveHref} />
        //   }
        //notifications={
        //  <Flashbar
        //    items={[
        //      {
        //        type: "info",
        //        dismissible: true,
        //        content: "This is an info flash message.",
        //        id: "message_1",
        //      },
        //    ]}
        //  />
        //}
        toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name='external' />
                </h3>
                <ul>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>

              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>

              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>

              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant='h1'
                actions={
                  <SpaceBetween size='s' direction='horizontal'>
                    <Button
                      onClick={handleEditButtonClick}
                      disabled={isUpdateButtonDisabled}
                    >
                      Edit
                    </Button>
                    <Button
                      onClick={handleDeleteConfirmation}
                      disabled={isButtonDisabled}
                    >
                      Delete
                    </Button>
                  </SpaceBetween>
                }
                info={
                  <Link
                    variant='info'
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }
              >
                {activeHref === "/vehicles/tyres"
                  ? `S/N : ${SerialNumber}`
                  : ""}
              </Header>
            }
          >
            <div className='contentPlaceholder' style={{ marginTop: isLoading ? "120px" : "0px" }}>
              {/*} <DetailDashboard />*/}

              {isLoading ? (
                <Box textAlign='center'>
                  <Spinner size='large' />
                  <Box variant='p'>Loading tyre data...</Box>
                </Box>
              ) : (
                <Container>
                  <Flashbar items={itemsFlashbar2} />
                  <ColumnLayout columns={2} minColumnWidth={500}>
                    <div>
                      <div>
                        <h1>Detail Tyre</h1>
                        <h3>S/N : {SerialNumber}</h3>
                      </div>
                      <div style={{ marginBottom: 20 }}>
                        <Flashbar items={itemsFlashbar} />
                      </div>
                      {tyreList.length > 0 ? (
                        tyreList.map((tyre) => (
                          <ColumnLayout
                            key={tyre.sn}
                            borders='horizontal'
                            columns={2}
                          >
                            <div>Tyre ID</div>
                            <div style={{ fontWeight: "bold" }}>
                              {tyre.tyreId}
                            </div>
                            <div>Sensor ID</div>
                            <div style={{ fontWeight: "bold" }}>
                              {tyre.sensorId}
                            </div>
                            <div>Brand</div>
                            <div>{tyre.brand}</div>
                            <div>Tyre Type</div>
                            <div>{tyre.typetyre}</div>
                            <div>Vehicle Code</div>
                            <div>{tyre.VehicleCode}</div>
                            <div>Tyre Status</div>
                            <div>
                              <StatusIndicator
                                type={tyre.Status ? "success" : "error"}
                              >
                                {tyre.Status ? "Plug" : "Unplug"}
                              </StatusIndicator>
                            </div>
                            <div>Current Alarm</div>
                            <div>
                              <StatusIndicator type='warning'>
                                (1) Under Pressure
                              </StatusIndicator>
                            </div>
                          </ColumnLayout>
                        ))
                      ) : (
                        <div>No tyre data found.</div>
                      )}
                    </div>

                    <DetailOverview />
                  </ColumnLayout>
                </Container>
              )}
            </div>
          </ContentLayout>
        }
        splitPanel={
          <SplitPanel header='Split panel header'>
            Split panel content
          </SplitPanel>
        }
      />
      <Modal
        onDismiss={() => setModalDeleteVisible(false)}
        visible={isModalDeleteVisible}
        closeAriaLabel='Close modal'
        header='Confirm Delete'
        footer={
          <SpaceBetween direction='horizontal' size='s'>
            <Button variant='link' onClick={() => setModalDeleteVisible(false)}>
              Cancel
            </Button>
            <Button variant='primary' onClick={handleDelete}>
              Confirm
            </Button>
          </SpaceBetween>
        }
      >
        <p>Are you sure you want to delete this Tyre?</p>
      </Modal>

      <Modal
        onDismiss={() => setModalUpdateVisible(false)}
        visible={isModalUpdateVisible}
        footer={
          <Box float='right'>
            <SpaceBetween direction='horizontal' size='xs'>
              <Button
                variant='link'
                onClick={() => setModalUpdateVisible(false)}
              >
                Cancel
              </Button>
              <Button variant='primary' onClick={handleUpdate}>
                Submit
              </Button>
            </SpaceBetween>
          </Box>
        }
        header='Edit Tyre'
      >
        <Container>
        <SpaceBetween direction='vertical' size='l'>
            <FormField label='Brand'>
              <Input
                value={tyreBrand}
                onChange={({ detail }) => settyreBrand(detail.value)}
              />
            </FormField>
            <FormField label='Type Tyre'>
              <Input
                value={tyreTipe}
                onChange={({ detail }) => settyreTipe(detail.value)}
              />
            </FormField>
            <FormField label='Serial Number'>
              <Input
                value={tyreSN}
                onChange={({ detail }) => settyreSN(detail.value)}
              />
            </FormField>
            <FormField label='Position Tyre'>
              <Input
                value={tyrePosition.toString()}
                onChange={({ detail }) =>
                  settyrePosition(parseInt(detail.value, 0))
                }
              />
            </FormField>
            <FormField label='Sensor ID'>
              <Input
                value={tyreSensorId.toString()}
                onChange={({ detail }) =>
                  settyreSensorId(parseInt(detail.value, 0))
                }
              />
            </FormField>
            <FormField label='Vehicle Code'>
              <Input
                value={tyreVehicleCode}
                onChange={({ detail }) => settyreVehicleCode(detail.value)}
              />
            </FormField>

            <FormField label='Pressure'>
              <Input
                value={tyrePressure.toString()}
                onChange={({ detail }) =>
                  settyrePressure(parseInt(detail.value, 0))
                }
              />
            </FormField>
            <FormField label='Temperature'>
              <Input
                value={tyreTemperature.toString()}
                onChange={({ detail }) =>
                  settyreTemperature(parseInt(detail.value, 0))
                }
              />
            </FormField>
            <FormField label='Battery'>
              <Input
                value={tyreBattery.toString()}
                onChange={({ detail }) =>
                  settyreBattery(parseInt(detail.value, 0))
                }
              />
            </FormField>
            <FormField label='Status Tyre'>
              <Checkbox
                checked={tyreStatus}
                onChange={({ detail }) => settyreStatus(detail.checked)} // Ensure tyreStatus is boolean
              >
                Plug
              </Checkbox>
            </FormField>
            </SpaceBetween>
        </Container>
      </Modal>
    </>
  );
};

export default TyreDetail;
